(function () {
  const solutions = {
    missingXDefault: {
      title: "Pages missing x-default",
      actions: [
        "Add an hreflang=\"x-default\" pointing to your global or primary market.",
        "Use your .com or international homepage as the fallback URL.",
        "Ensure x-default appears on all language variants."
      ],
      lifecycle: "Without x-default, Google has no fallback when language or region can’t be matched.",
      tips: [
        "Shopify Markets does not always add x-default automatically.",
        "Verify both live HTML and sitemap output."
      ]
    },

    missingSelf: {
      title: "Missing self-referencing hreflang",
      actions: [
        "Ensure each page includes an hreflang pointing to itself.",
        "Check product, collection, page, and blog templates separately.",
        "Confirm the self-reference URL matches the canonical."
      ],
      lifecycle: "Self-referencing tags confirm the page’s own language identity to Google.",
      tips: [
        "Missing self-references often come from custom themes or apps.",
        "This is one of the most common Shopify hreflang errors."
      ]
    },

    redirectedTargets: {
      title: "Hreflang points to redirected or broken URLs",
      actions: [
        "Update hreflang URLs so they resolve with a 200 status.",
        "Remove references to legacy or deleted market URLs.",
        "Re-save Markets after URL structure changes."
      ],
      lifecycle: "Google ignores hreflang tags that point to redirects or 404s.",
      tips: [
        "Always test hreflang targets with a live URL check.",
        "Avoid pointing hreflang at redirected domains or folders."
      ]
    },

    missingReciprocal: {
      title: "Missing reciprocal hreflang tags",
      actions: [
        "Ensure every language version references all other variants.",
        "Confirm reciprocity across products, collections, and blogs.",
        "Fix partial mappings caused by unpublished market pages."
      ],
      lifecycle: "Hreflang must be bidirectional to be valid.",
      tips: [
        "One-way hreflang is treated as invalid by Google.",
        "Blogs are often the first place reciprocity breaks."
      ]
    },

    nonCanonical: {
      title: "Hreflang points to non-canonical URLs",
      actions: [
        "Align canonical URLs with market-specific URLs.",
        "Remove global canonicals pointing to the primary domain.",
        "Ensure each market page canonicalises to itself."
      ],
      lifecycle: "Google prioritises canonicals over hreflang when they conflict.",
      tips: [
        "This is a major Shopify Markets pitfall.",
        "Fix canonicals before troubleshooting hreflang further."
      ]
    },

    invalidCodes: {
      title: "Incorrect hreflang values",
      actions: [
        "Use ISO 639-1 language codes and ISO 3166-1 region codes.",
        "Replace invalid values like en-UK with en-GB.",
        "Audit all templates and sitemap entries."
      ],
      lifecycle: "Invalid codes cause hreflang tags to be ignored entirely.",
      tips: [
        "Google is strict—one invalid code breaks the tag.",
        "Always validate codes before launch."
      ]
    },

    inconsistentLanguage: {
      title: "Inconsistent language attributes",
      actions: [
        "Ensure page content matches the declared hreflang language.",
        "Translate headings, body content, and metadata.",
        "Avoid English content on non-English URLs."
      ],
      lifecycle: "Google uses content signals, not hreflang alone, to determine language.",
      tips: [
        "Auto-translated or duplicated content weakens hreflang effectiveness.",
        "Language mismatch is common on blogs and CMS pages."
      ]
    },

    duplicateLanguage: {
      title: "Multiple pages for the same language",
      actions: [
        "Consolidate to one URL per language and region.",
        "Remove filtered, parameterised, or legacy URLs from hreflang.",
        "Clean up Shopify Markets mappings."
      ],
      lifecycle: "Each hreflang value must map to exactly one URL.",
      tips: [
        "Duplicate mappings dilute ranking signals.",
        "This often happens after migrations or redesigns."
      ]
    },

    sameUrlMultipleLangs: {
      title: "Same URL used for multiple languages",
      actions: [
        "Assign unique URLs for each language and region.",
        "Fix reused URLs across Markets.",
        "Ensure translated pages have distinct paths."
      ],
      lifecycle: "A single URL cannot represent multiple languages.",
      tips: [
        "This usually indicates missing translations.",
        "Google will ignore conflicting hreflang mappings."
      ]
    },

    canonicalOverride: {
      title: "Canonical overriding hreflang",
      actions: [
        "Update theme logic so canonicals match market URLs.",
        "Remove hard-coded global canonicals.",
        "Test canonicals on every market page type."
      ],
      lifecycle: "Canonicals override hreflang when they conflict.",
      tips: [
        "Fix canonicals first—hreflang depends on them.",
        "This is one of the biggest Shopify SEO blockers."
      ]
    },

    untranslatedContent: {
      title: "Markets enabled but content not translated",
      actions: [
        "Translate product, collection, and blog content.",
        "Localise metadata, not just body text.",
        "Unpublish markets that aren’t ready."
      ],
      lifecycle: "Hreflang without localisation is ignored by Google.",
      tips: [
        "Markets ≠ translations.",
        "Relevance matters more than structure."
      ]
    },

    geoRedirects: {
      title: "Geo-redirects conflicting with hreflang",
      actions: [
        "Disable forced IP redirects.",
        "Use banners or selectors instead of redirects.",
        "Ensure Googlebot can crawl all versions."
      ],
      lifecycle: "Hard redirects prevent Google from crawling hreflang pages.",
      tips: [
        "Google recommends no forced geo-redirects.",
        "This issue often hides real hreflang problems."
      ]
    },

    noindexMarkets: {
      title: "Market pages set to noindex",
      actions: [
        "Remove noindex from market pages.",
        "Audit SEO apps and robots rules.",
        "Confirm indexability in Search Console."
      ],
      lifecycle: "Noindex pages invalidate hreflang mappings.",
      tips: [
        "A noindex page cannot participate in hreflang.",
        "This is common with staging or draft markets."
      ]
    }
  };

  const selectEl = document.getElementById("kpi-problem-select");
  const solutionEl = document.getElementById("kpi-solution");

  function renderSolution(key) {
    const data = solutions[key];
    if (!data) {
      solutionEl.innerHTML = "";
      return;
    }

    const actionsList = data.actions.map(item => `<li>${item}</li>`).join("");

    solutionEl.innerHTML = `
      <span class="kpi-tag">Hreflang fix</span>
      <h4>${data.title}</h4>
      <ul>${actionsList}</ul>
      <strong>Why this matters:</strong>
      <p>${data.lifecycle}</p>
      <strong>Notes:</strong>
      <ul>${data.tips.map(item => `<li>${item}</li>`).join("")}</ul>
    `;
  }

  selectEl.addEventListener("change", function () {
    renderSolution(this.value);
  });
})();
